import * as React from "react";
import range from "lodash/range";
import { Field } from "formik";
import { InputDescription, Select } from "components/common";
import StringUtils from "util/StringUtils";
const OptionValue = ({ label }) => /* @__PURE__ */ React.createElement("span", null, "Day ", label);
const DayOfMonthSelect = ({ id, required = false }) => {
  const daysOptions = range(1, 31 + 1).map((day) => {
    const stringDay = String(day);
    return { value: stringDay, label: stringDay };
  });
  return /* @__PURE__ */ React.createElement(Field, { name: id }, ({ field: { name, value, onChange, onBlur }, meta: { touched, error } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      onBlur,
      onChange: (newValue) => onChange({
        target: { value: newValue, name }
      }),
      options: daysOptions,
      inputId: name,
      placeholder: "Select day of the month",
      required,
      valueRenderer: OptionValue,
      value: value ? StringUtils.stringify(value) : void 0
    }
  ), error && touched && /* @__PURE__ */ React.createElement(InputDescription, { error, className: "no-bm" })));
};
export default DayOfMonthSelect;
